import { render, staticRenderFns } from "./ReferralListVerification.vue?vue&type=template&id=71785725"
import script from "./ReferralListVerification.vue?vue&type=script&lang=js"
export * from "./ReferralListVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports